import { Capacitor } from '@capacitor/core';
import { lazy } from 'react';

/**
 * Dynamically imports a module based on the platform
 * @param {Function} importFn - The dynamic import function (e.g. () => import('./Component'))
 * @returns {Promise} - The imported module
 */
export const platformImport = (importFn) => {
  // For Android, use direct import
  if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android') {
    return importFn();
  }
  // For web, use lazy loading
  return importFn();
};

/**
 * Creates a platform-specific import function that works with React.lazy
 * @param {Function} importFn - The dynamic import function (e.g. () => import('./Component'))
 * @returns {Object} - A React.lazy compatible object
 */
export const createPlatformImport = (importFn) => {
  // For Android, use direct import
  if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android') {
    return lazy(() => importFn());
  }
  // For web, use lazy loading
  return lazy(importFn);
}; 